import angular from 'angular'

// components
import profileMenu from './component/profileMenu.js'

export default angular
  .module('portalApp.profileMenu', [])
  .component('profileMenu', profileMenu).name
